export const CardBackground = () => {
  return (
    <div className="relative mt-8 h-24 w-full overflow-hidden rounded-xl bg-[url('/img/background-image.png')] bg-cover	bg-center">
      <div className="absolute inset-0 h-full w-full bg-gray-900/75" />
    </div>
  );
};
